export function timeToMinimapY(timeMs, totalDurationMs, minimapHeight) {
  const duration = Math.max(1, Number(totalDurationMs) || 0)
  return clamp(Number(timeMs) / duration * Math.max(0, Number(minimapHeight) || 0), 0, Math.max(0, Number(minimapHeight) || 0))
}

export function minimapViewportGeometry({ scrollTop, viewportHeight, contentHeight, minimapHeight }) {
  const height = Math.max(0, Number(minimapHeight) || 0)
  const content = Math.max(1, Number(contentHeight) || 0)
  const viewport = clamp(Number(viewportHeight) || 0, 0, content)
  const maxScroll = Math.max(0, content - viewport)
  const top = maxScroll > 0 ? clamp(Number(scrollTop) || 0, 0, maxScroll) / content * height : 0
  return {
    top,
    height: Math.min(height, Math.max(2, viewport / content * height)),
  }
}

export function minimapYToScrollTop(y, minimapHeight, contentHeight, viewportHeight) {
  const height = Math.max(1, Number(minimapHeight) || 0)
  const content = Math.max(1, Number(contentHeight) || 0)
  const viewport = clamp(Number(viewportHeight) || 0, 0, content)
  const targetCenter = clamp(Number(y) || 0, 0, height) / height * content
  return clamp(targetCenter - viewport / 2, 0, Math.max(0, content - viewport))
}

export function minimapYToPlaybackMs(y, minimapHeight, totalDurationMs) {
  const height = Math.max(1, Number(minimapHeight) || 0)
  const duration = Math.max(0, Number(totalDurationMs) || 0)
  return clamp(Number(y) || 0, 0, height) / height * duration
}

export function pitchToMinimapX(pitch, minPitch, maxPitch, minimapWidth) {
  const width = Math.max(0, Number(minimapWidth) || 0)
  const min = Number(minPitch)
  const max = Math.max(min + 1, Number(maxPitch))
  return clamp((Number(pitch) - min) / (max - min) * width, 0, width)
}

export function durationToMinimapHeight(durationMs, totalDurationMs, minimapHeight, minimumHeight = 1) {
  const duration = Math.max(1, Number(totalDurationMs) || 0)
  return Math.max(Math.max(0, Number(minimumHeight) || 0), Math.max(0, Number(durationMs) || 0) / duration * Math.max(0, Number(minimapHeight) || 0))
}

export function buildMinimapNoteGeometry(timedTracks, { width, height, totalDurationMs, minPitch, maxPitch }) {
  const markWidth = Math.max(1, Math.min(3, Math.max(0, Number(width) || 0) / Math.max(1, Number(maxPitch) - Number(minPitch) + 1)))
  return (timedTracks ?? []).flatMap(track => (track.events ?? [])
    .filter(event => event.note != null)
    .map(event => ({
      trackIndex: track.trackIndex,
      x: pitchToMinimapX(event.note, minPitch, maxPitch, width),
      y: timeToMinimapY(event.startMs, totalDurationMs, height),
      width: markWidth,
      height: durationToMinimapHeight(event.durationMs, totalDurationMs, height),
    })))
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value))
}
